import { useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import { useGoogleMap } from '@react-google-maps/api';
import { isEqual } from 'lodash';

Bounds.propTypes = {
    coordinates: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string])),
    padding: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.shape({
            top: PropTypes.number,
            left: PropTypes.number,
            right: PropTypes.number,
            bottom: PropTypes.number,
        }),
    ]),
};

function Bounds({ coordinates, padding }) {
    const map = useGoogleMap();

    useEffect(() => {
        if (coordinates.length > 0) {
            const bounds = new google.maps.LatLngBounds();

            coordinates.forEach((position) => {
                if (typeof position === 'string') {
                    google.maps.geometry.encoding.decodePath(position).forEach((point) => {
                        bounds.extend(point);
                    });
                } else {
                    bounds.extend(position);
                }
            });

            if (map) {
                map.fitBounds(bounds, padding);
            }
        }
    }, [map, coordinates, padding]);

    return null;
}

function areEqual(prevProps, nextProps) {
    return !nextProps.coordinates?.forceUpdate && isEqual(prevProps.coordinates, nextProps.coordinates);
}

export default memo(Bounds, areEqual);
